export const ModifiedPriceType = {
  CustomPrice: 'CustomPrice',
  Discount: 'Discount',
  DiscountPercentage: 'DiscountPercentage',
}
